// extracted by mini-css-extract-plugin
export var divider = "_3g-0";
export var dividerText = "_3g-1";